export const MICRODISTRICT_RATING_LOAD = '@@microdistrictRating/MICRODISTRICT_RATING_LOAD';
export const MICRODISTRICT_RATING_IGNORE = '@@microdistrictRating/MICRODISTRICT_RATING_IGNORE';

export const SIMILAR_OBJECTS_LOAD = '@@similarObjects/SIMILAR_OBJECTS_LOAD';
export const SIMILAR_OBJECTS_IGNORE = '@@similarObjects/SIMILAR_OBJECTS_IGNORE';
